export default {
    previewContentWrapper: {
        width: 750,
        margin: '0 auto',
        paddingBottom: 130,
        '@media only screen and (max-width: 767px)': {
            width: '100%',
            paddingLeft: '20px',
            paddingRight: '20px'
        }
    },
    loaderWrapper: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: 'auto',
        width: 40,
        height: 40
    },
    contentWrapper: {
        margin: '120px auto 0'
    },
    footer: {
        position: 'fixed',
        padding: '0 40px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 80,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#fff',
        color: '#fff',
        '& svg': {
            height: '100%'
        }
    }
};
